import { literal, union } from 'io-ts/Decoder';

export const Certainty = union(
	literal('ai-confirmed'),
	literal('ai-suggested'),
	literal('input-required'),
	literal('user-confirmed')
);
